export enum LocationIconClass {
    ALARM = 'alarm',
    WARNING = 'warning', 
    NORMAL = 'normal',
    INACTIVE = 'inactive',
    MAINTENANCE = 'maintenance'
}